import { useCrossProductUrlWrapper } from '@atlassiansox/analytics-cross-product-interaction-client';
import { fg } from '@atlaskit/platform-feature-flags';
import { NAVIGATION_CHANNEL, OPERATIONAL_EVENT_TYPE } from './analytics';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const useAnalyticsUrlWrapper = (product: string, subProduct?: string) => {
	// Assets still uses the switcher in Jira so its product is "jira". 
	// However, for XPC we want the source to be "assets" to match the implementation in GAS.
	const isAssets = fg('navx-5079-switcher-subproduct-xpc-source') && subProduct === 'assets';
	const analyticsUrlWrapper = useCrossProductUrlWrapper({
		bridge: 'appSwitcher',
		product: isAssets ? 'assets' : product ?? 'appSwitcher',
		subProduct: !isAssets ? subProduct : undefined,
	});
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (url: string): string => {
		try {
			const parsedUrl = new URL(url);
			const continueParam = parsedUrl.searchParams.get('continue');
			if (!continueParam) {
				// If there is no continue param, we just wrap the whole URL
				return analyticsUrlWrapper(url);
			}

			// Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
			const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
			// Reconstruct the original URL with the wrapped continue param
			parsedUrl.searchParams.set('continue', wrappedContinueUrl);
			return parsedUrl.toString();
		} catch (e) {
			createAnalyticsEvent({
				eventType: OPERATIONAL_EVENT_TYPE,
				action: 'failed',
				actionSubject: 'analyticsUrlWrapping',
				attributes: {
					url: url,
					product,
				},
			}).fire(NAVIGATION_CHANNEL);
			return url;
		}
	};
};
